import React from 'react'
import './DescriptionBox.css'

const DescriptionBox = () => {
  return (
    <div className='descriptionbox'>
      <div className="descriptionbox-navigator">
        <div className="descriptionbox-nav-box">Description</div>
        <div className="descriptionbox-nav-box fade">Reviews (122)</div>
      </div>
      <div className="descriptionbox-description">
        <p>
        wedfhfvsbvfvbfhv v hf f fggg sahf gf fsadkjfgf  afgdf af sdf af d f d akf hd afg ahjfg fg   df 
        df eggdf sff
        dfy adufy ayf dsg jhv  v  ad,hhglagf
        afvh af uhf af afua  af af  f alhfjh dfvb,cmznbv bv cmvz w
        v hfg g vgv v   yu vfvb
        </p>
        <p>
            fedgedfhgfdsfkjsdgadfsgajf
            agf  fagggbnhh sth n syt ysry 5y sy yh nh jhhnd th dgjh njk  hsysuedkn yj y jnj jg nn ncdd j jdyj jm fdgdh m,  kdghfn tysy ytj yjmn 
        </p>
      </div>
    </div>
  )
}

export default DescriptionBox
